import {useForceUpdateUntil} from "./useForceUpdateUntil";
import {useControllers} from "./useControllers";
import {useMemo, useState} from 'react';

export function useNavigateTo(page?: string, replace: boolean = false): void {
    const http = useControllers().http;
    const [done, setDone] = useState<boolean>(false);
    const tick = useForceUpdateUntil(done);

    useMemo(() => {
        http.navigateTo(page, replace).then(() => setDone(true));
    }, [tick]);
}